// Focal-point registry for campaign assets. Admin overrides live in
// settings.focal_points (editable from Media Library / Homepage editors) and
// arrive via store config. Unknown assets default to the upper third —
// faces sit high in a portrait frame, so never dead-centre.
export const ASSET_DIMS = {
  "/assets/pia/pia-hd-1.webp": [494, 889],
  "/assets/pia/pia-hd-2.webp": [488, 889],
  "/assets/pia/pia-hd-3.webp": [488, 889],
  "/assets/pia/pia-hd-4.webp": [494, 889],
  "/assets/pia/pia-editorial-1.webp": [494, 1116],
  "/assets/pia/pia-editorial-2.webp": [488, 1116],
  "/assets/pia/pia-editorial-3.webp": [488, 1116],
  "/assets/pia/pia-editorial-4.webp": [494, 1116],
  "/assets/pia/pia-ring-1.webp": [494, 1116],
  "/assets/pia/pia-ring-2.webp": [488, 1116],
  "/assets/pia/pia-ring-3.webp": [488, 1116],
  "/assets/pia/pia-ring-4.webp": [494, 1116],
  "/assets/pia/pia-ear-1.webp": [1300, 1578],
  "/assets/pia/pia-intro-poster.jpg": [1080, 480],
};

export const FOCAL_DEFAULTS = {
  "/assets/pia/pia-hd-1.webp": { x: 50, y: 50 },
  "/assets/pia/pia-hd-2.webp": { x: 50, y: 25 },
  "/assets/pia/pia-hd-3.webp": { x: 45, y: 22 },
  "/assets/pia/pia-hd-4.webp": { x: 50, y: 80 },
  "/assets/pia/pia-editorial-1.webp": { x: 50, y: 32 },
  "/assets/pia/pia-editorial-2.webp": { x: 55, y: 48 },
  "/assets/pia/pia-editorial-3.webp": { x: 50, y: 45 },
  "/assets/pia/pia-editorial-4.webp": { x: 50, y: 20 },
  "/assets/pia/pia-ring-1.webp": { x: 55, y: 52 },
  "/assets/pia/pia-ring-2.webp": { x: 50, y: 42 },
  "/assets/pia/pia-ring-3.webp": { x: 50, y: 26 },
  "/assets/pia/pia-ring-4.webp": { x: 50, y: 24 },
  "/assets/pia/pia-ear-1.webp": { x: 55, y: 45 },
  "/assets/pia/pia-intro-poster.jpg": { x: 50, y: 38 },
};

export function focalFor(src, config) {
  const override = (config?.focal_points || {})[src];
  if (override) return override;
  const media = (config?.media_focals || {})[src];
  if (media) return media;
  return FOCAL_DEFAULTS[src] || { x: 50, y: 30 };
}

export function objectPosition(src, config) {
  const f = focalFor(src, config);
  return `${f.x}% ${f.y}%`;
}

export function isPortrait(src, assetDims) {
  const d = ASSET_DIMS[src] || assetDims?.[src];
  return d ? d[1] > d[0] : false;
}
